module.exports = __webpack_public_path__ + "static/phone3-a9166da4a3f6ef3f2cf425ffd18d7237.png";